
import React from 'react';
import { RCTag } from '@reverbdotcom/cadence/components';


interface Props {
  isComplete: boolean;
  message: string;
}

export function TaxProfileStatus({ isComplete, message }: Props) {
  return (
    <RCTag
      variant={isComplete ? 'success' : 'default'}
    >
      <span>{message}</span>
    </RCTag>
  );
}

export default TaxProfileStatus;
